import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import type MultiChannelLink from "@/interface/MultiChannelLink";
import type FormCCOtp from "@/interface/FormCCOtp";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import CCOnboardFormService from "@/service/restfulService/CCOnboardFormService";

export default function basicInformationSubmit(
  ccFormValue: Ref<FormCC>,
  prop: any,
  multiChannel: Ref<MultiChannelLink>,
  otp: Ref<FormCCOtp>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  page1Overlay: Ref<boolean>,
  failedStatus: Ref<boolean>,
  creditLimit: Ref<string>,
  status: Ref<string>,
  newForm: Ref<boolean>,
  cifErrorFlag: Ref<boolean>,
  biometricVerification: Ref<string>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  const exist = ref(false);
  const editExist = ref(true);

  const currentYearLastTwoDigits = parseInt(
    new Date().getFullYear().toString(),
    10
  );
  const last4DigitsAsNumber = parseInt(
    ccFormValue.value.basicInformation.dob.substring(
      ccFormValue.value.basicInformation.dob.length - 4
    ),
    10
  );
  const age = currentYearLastTwoDigits - last4DigitsAsNumber;
  const cardModel = {
    productCode: prop.cardId,
    age: age,
    nationality: ccFormValue.value.basicInformation.nationality,
    grossSalary: ccFormValue.value.basicInformation.grossSalary,
  };

  const dropOffStep: Record<string, number> = {
    S1: 1,
    S2: 2,
    S3: 3,
    S4: 4,
    S5: 5,
    S6: 6,
    S7: 7,
    S8: 8,
    S9: 9,
    S10: 10,
    S11: 11,
    S12: 12,
  };

  const convertValue = (original: string) => {
    return dropOffStep[original] || "Unknown";
  };

  //Basic Information
  const requestModel = {
    type: prop.type != "" ? prop.type : "",
    cardId: prop.cardId,
    idNo: ccFormValue.value.basicInformation.idNo,
    oldIc:
      ccFormValue.value.basicInformation.idType == "1"
        ? ""
        : ccFormValue.value.basicInformation.oldIc,
    originalUrl: prop.originalUrl,
    errorMessage: prop.errorMessage,
    tmkCrmRefNo: multiChannel.value.crfn,
    marketingCampaignId: multiChannel.value.mci,
    merchantId: multiChannel.value.mc,
    branch: multiChannel.value.bc,
    applicationChannel: multiChannel.value.acc,
    recruiterId: multiChannel.value.rci,
    region: prop.region,
    basicInformation: {
      // title: ccFormValue.value.value.basicInformation.title,
      fullName: ccFormValue.value.basicInformation.name,
      idTypeCode: ccFormValue.value.basicInformation.idType,
      idNo: ccFormValue.value.basicInformation.idNo,
      oldIc:
        ccFormValue.value.basicInformation.idType == "1"
          ? ""
          : ccFormValue.value.basicInformation.oldIc,
      militaryNo:
        ccFormValue.value.basicInformation.idType == "1"
          ? ""
          : ccFormValue.value.basicInformation.militaryNo,
      nationalityCode: ccFormValue.value.basicInformation.nationality,
      dateOfBirth: ccFormValue.value.basicInformation.dob,
      emailAddress: ccFormValue.value.basicInformation.email,
      mobileCountryCode: ccFormValue.value.basicInformation.countryCode,
      mobileNumber: ccFormValue.value.basicInformation.mobileNo,
      homePhoneCountryCode:
        ccFormValue.value.basicInformation.homePhoneNo != ""
          ? ccFormValue.value.basicInformation.homeCountryCode
          : "",
      homePhoneNumber: ccFormValue.value.basicInformation.homePhoneNo,
      grossMonthlySalary: ccFormValue.value.basicInformation.grossSalary,
      netMonthlySalary: ccFormValue.value.basicInformation.netSalary,
      professionCode: ccFormValue.value.basicInformation.profession,
      professionOthers: ccFormValue.value.basicInformation.others,
      anyLoan:
        ccFormValue.value.basicInformation.question1 == "Yes" ? true : false,
      repayment: ccFormValue.value.basicInformation.repayment,
      jcklMembershipNo: ccFormValue.value.basicInformation.jcklMembershipNo,
      jcklClubStatus: ccFormValue.value.basicInformation.jcklClubStatus,
    },
  };

  if (
    ccFormValue.value.webFormRequestId != "" ||
    otp.value.principalStatus === "falseBoth" ||
    otp.value.otpMobile.status === "falseOtp" ||
    otp.value.otpEmail.status === "falseEmail"
  ) {
    ccFormValue.value.ekyc.action = "N";
    const requestModel2 = {
      // dropOffStep: "S1",
      webFormRequestId: ccFormValue.value.webFormRequestId,
      cardId: prop.cardId,
      icNumber: ccFormValue.value.basicInformation.idNo,
      webFormDetails: {
        basicInformation: {
          // title: ccFormValue.value.value.basicInformation.title,
          fullName: ccFormValue.value.basicInformation.name,
          idTypeCode: ccFormValue.value.basicInformation.idType,
          idNo: ccFormValue.value.basicInformation.idNo,
          oldIc:
            ccFormValue.value.basicInformation.idType == "1"
              ? ""
              : ccFormValue.value.basicInformation.oldIc,
          militaryNo:
            ccFormValue.value.basicInformation.idType == "1"
              ? ""
              : ccFormValue.value.basicInformation.militaryNo,
          nationalityCode: ccFormValue.value.basicInformation.nationality,
          dateOfBirth: ccFormValue.value.basicInformation.dob,
          emailAddress: ccFormValue.value.basicInformation.email,
          mobileCountryCode: ccFormValue.value.basicInformation.countryCode,
          mobileNumber: ccFormValue.value.basicInformation.mobileNo,
          homePhoneCountryCode:
            ccFormValue.value.basicInformation.homePhoneNo != ""
              ? ccFormValue.value.basicInformation.homeCountryCode
              : "",
          homePhoneNumber: ccFormValue.value.basicInformation.homePhoneNo,
          grossMonthlySalary: ccFormValue.value.basicInformation.grossSalary,
          netMonthlySalary: ccFormValue.value.basicInformation.netSalary,
          professionCode: ccFormValue.value.basicInformation.profession,
          professionOthers: ccFormValue.value.basicInformation.others,
          anyLoan:
            ccFormValue.value.basicInformation.question1 == "Yes"
              ? true
              : false,
          repayment: ccFormValue.value.basicInformation.repayment,
          jcklMembershipNo: ccFormValue.value.basicInformation.jcklMembershipNo,
          jcklClubStatus: ccFormValue.value.basicInformation.jcklClubStatus,
        },
      },
    };

    const requestModel3 = {
      webFormRequestId: ccFormValue.value.webFormRequestId,
      name: ccFormValue.value.basicInformation.name,
      idType: ccFormValue.value.basicInformation.idType,
      idNo: ccFormValue.value.basicInformation.idNo,
    };
    MasterService.editValidate(requestModel3, ccFormValue.value.token)
      .then((res) => {
        if (res.status == 200) {
          if (res.data.response == "Exist") {
            editExist.value = true;
          } else {
            editExist.value = false;
          }
          if (
            ccFormValue.value.basicInformation.idType == "0" &&
            ccFormValue.value.ekyc.preStatus != "" &&
            ccFormValue.value.preAss.webFormRequestId
          ) {
            const requestModel = {
              webFormRequestId: ccFormValue.value.webFormRequestId,
              preRequestId: ccFormValue.value.preAss.webFormRequestId,
              grossSalary: ccFormValue.value.basicInformation.grossSalary,
            };
            MasterService.preAssesmentValidate(
              requestModel,
              ccFormValue.value.token
            )
              .then((res) => {
                if (res.status == 200) {
                  if (res.data.responseModel.check == "Exist") {
                    exist.value = true;
                  } else {
                    exist.value = false;
                  }
                  continueFunction();
                }
              })
              .catch((e) => {
                if (e.response && e.response.data.code == "WB-401") {
                  // EndSession
                  isTimeOut.value = false;
                  isSessionEnd.value = true;
                }
                page1Overlay.value = false;
                jumpStep(14, "denied2", "3");
              });
          } else {
            continueFunction();
          }
        }
      })
      .catch((e) => {
        if (e.response && e.response.data.code == "WB-401") {
          // EndSession
          isTimeOut.value = false;
          isSessionEnd.value = true;
        }
      });
    const continueFunction = () => {
      MasterService.pageSubmit(requestModel2, ccFormValue.value.token)
        .then((res) => {
          if (res.status == 200) {
            if (prop.type == "CR_SL") {
              page1Overlay.value = false;
              jumpStep(0, "", "1");
            }
            //gt changes
            else if (
              editExist.value == false &&
              ccFormValue.value.basicInformation.idType == "0" &&
              biometricVerification.value != "true"
            ) {
              const requestModel = {
                webFormRequestId: ccFormValue.value.ekyc.webFormRequestId,
              };
              MasterService.removeEKYC(
                requestModel,
                ccFormValue.value.token
              ).then((res) => {
                if (res.status == 200) {
                  page1Overlay.value = false;
                  failedStatus.value = false;
                  ccFormValue.value.ekyc.status = "";
                  jumpStep(2, "", "1");
                }
              });
            }
            //no changes or cc app with bio flag Y
            else if (
              (editExist.value == true &&
                ccFormValue.value.basicInformation.idType == "0") ||
              biometricVerification.value == "true"
            ) {
              //type others || type == bio && bioflag false
              if (
                (ccFormValue.value.ekyc.status == "" ||
                  ccFormValue.value.ekyc.status == "PENDING" ||
                  ccFormValue.value.ekyc.status == "FAILED") &&
                biometricVerification.value != "true"
              ) {
                failedStatus.value = false;
                page1Overlay.value = false;
                jumpStep(2, "", "1");
              }

              //Check otp
              else {
                if (otp.value.verified == "true") {
                  if (ccFormValue.value.ekyc.preStatus != "") {
                    if (exist.value == true) {
                      page1Overlay.value = false;
                      jumpStep(4, "", "3");
                    } else {
                      const requestModel = {
                        webFormRequestId: ccFormValue.value.webFormRequestId,
                        name: ccFormValue.value.basicInformation.name,
                        icNo: ccFormValue.value.basicInformation.idNo,
                        dateOfBirth: ccFormValue.value.basicInformation.dob,
                        cardBusinessCode: prop.cardId,
                        nationalityCode:
                          ccFormValue.value.basicInformation.nationality,
                        phoneNo:
                          ccFormValue.value.basicInformation.countryCode +
                          ccFormValue.value.basicInformation.mobileNo,
                        grossIncome:
                          ccFormValue.value.basicInformation.grossSalary.toString(),
                        netIncome:
                          ccFormValue.value.basicInformation.netSalary.toString(),
                        refNo: ccFormValue.value.refNo,
                      };
                      MasterService.preAssesment(
                        requestModel,
                        ccFormValue.value.token
                      )
                        .then((res) => {
                          if (res.status == 200) {
                            // page3Overlay.value = false;
                            ccFormValue.value.preAss.webFormRequestId =
                              res.data.responseModel.webFormRequestId;
                            ccFormValue.value.dsrBurst =
                              res.data.responseModel.dSRStatus;
                            ccFormValue.value.dropOffStep = 5;
                            creditLimit.value =
                              res.data.responseModel.preAssessLimit;
                            ccFormValue.value.ctosScore =
                              res.data.responseModel.ctosScore;
                            if (
                              res.data.responseModel.preAssessStatus ==
                              "DECLINED"
                            ) {
                              page1Overlay.value = false;
                              jumpStep(14, "denied2", "3");
                            } else {
                              ccFormValue.value.ekyc.preStatus =
                                res.data.responseModel.preAssessStatus;
                              page1Overlay.value = false;
                              jumpStep(4, "", "3");
                            }
                          }
                        })
                        .catch((e) => {
                          if (e.response && e.response.data.code == "WB-401") {
                            // EndSession
                            isTimeOut.value = false;
                            isSessionEnd.value = true;
                          }
                          page1Overlay.value = false;
                          ccFormValue.value.ekyc.preStatus = "DOWN";
                          jumpStep(4, "", "3");
                          // jumpStep(14, "denied2", "3");
                        });
                    }
                  } else {
                    page1Overlay.value = false;
                    jumpStep(4, "", "1");
                  }
                } else {
                  page1Overlay.value = false;
                  jumpStep(3, "", "1");
                }
              }
            }
            //if no changes
            else {
              if (
                ccFormValue.value.ekyc.status == "PENDING" ||
                ccFormValue.value.ekyc.status == ""
              ) {
                if (ccFormValue.value.basicInformation.idType == "0") {
                  ccFormValue.value.ekyc.action = "N";
                  page1Overlay.value = false;
                  jumpStep(2, "", "1");
                } else {
                  ccFormValue.value.ekyc.action = "N";
                  if (
                    (prop.isAutoPopulate &&
                      otp.value.populateUpdatedFlag == "false") ||
                    (cifErrorFlag.value &&
                      otp.value.populateUpdatedFlag == "false")
                  ) {
                    const requestModel2 = {
                      webFormRequestId: ccFormValue.value.webFormRequestId,
                      type: "CC_P",
                      otpType: "mobileOtp",
                    };
                    CCOnboardFormService.updateStatus(requestModel2, prop.token)
                      .then((res) => {
                        if (res.status == 200) {
                          const requestModel3 = {
                            webFormRequestId:
                              ccFormValue.value.webFormRequestId,
                            type: "CC_P",
                            otpType: "emailOtp",
                          };
                          CCOnboardFormService.updateStatus(
                            requestModel3,
                            prop.token
                          )
                            .then((res) => {
                              if (res.status == 200) {
                                (otp.value.populateUpdatedFlag = "true"),
                                  (page1Overlay.value = false),
                                  jumpStep(4, "", "1");
                              }
                            })
                            .catch((e) => {
                              if (
                                e.response &&
                                e.response.data.code == "WB-401"
                              ) {
                                // EndSession
                                isTimeOut.value = false;
                                isSessionEnd.value = true;
                              }
                              page1Overlay.value = false;
                            });
                        }
                      })
                      .catch((e) => {
                        if (e.response && e.response.data.code == "WB-401") {
                          // EndSession
                          isTimeOut.value = false;
                          isSessionEnd.value = true;
                        }
                        page1Overlay.value = false;
                      });
                  } else if (otp.value.verified == "true") {
                    page1Overlay.value = false;
                    jumpStep(4, "", "1");
                  } else {
                    page1Overlay.value = false;
                    jumpStep(3, "", "1");
                  }
                }
              } else {
                if (status.value === "false") {
                  if (ccFormValue.value.basicInformation.idType == "0") {
                    if (ccFormValue.value.ekyc.preStatus != "") {
                      if (exist.value == true) {
                        page1Overlay.value = false;
                        jumpStep(4, "", "3");
                      } else {
                        const requestModel = {
                          webFormRequestId: ccFormValue.value.webFormRequestId,
                          name: ccFormValue.value.basicInformation.name,
                          icNo: ccFormValue.value.basicInformation.idNo,
                          dateOfBirth: ccFormValue.value.basicInformation.dob,
                          cardBusinessCode: prop.cardId,
                          nationalityCode:
                            ccFormValue.value.basicInformation.nationality,
                          phoneNo:
                            ccFormValue.value.basicInformation.countryCode +
                            ccFormValue.value.basicInformation.mobileNo,
                          grossIncome:
                            ccFormValue.value.basicInformation.grossSalary.toString(),
                          netIncome:
                            ccFormValue.value.basicInformation.netSalary.toString(),
                          refNo: ccFormValue.value.refNo,
                        };
                        MasterService.preAssesment(
                          requestModel,
                          ccFormValue.value.token
                        )
                          .then((res) => {
                            if (res.status == 200) {
                              // page3Overlay.value = false;
                              ccFormValue.value.preAss.webFormRequestId =
                                res.data.responseModel.webFormRequestId;
                              ccFormValue.value.dsrBurst =
                                res.data.responseModel.dSRStatus;
                              ccFormValue.value.dropOffStep = 5;
                              creditLimit.value =
                                res.data.responseModel.preAssessLimit;
                              ccFormValue.value.ctosScore =
                                res.data.responseModel.ctosScore;
                              if (
                                res.data.responseModel.preAssessStatus ==
                                "DECLINED"
                              ) {
                                page1Overlay.value = false;
                                jumpStep(14, "denied2", "3");
                              } else {
                                ccFormValue.value.ekyc.preStatus =
                                  res.data.responseModel.preAssessStatus;
                                page1Overlay.value = false;
                                jumpStep(4, "", "3");
                              }
                            }
                          })
                          .catch((e) => {
                            if (
                              e.response &&
                              e.response.data.code == "WB-401"
                            ) {
                              // EndSession
                              isTimeOut.value = false;
                              isSessionEnd.value = true;
                            }
                            page1Overlay.value = false;
                            ccFormValue.value.ekyc.preStatus = "DOWN";
                            jumpStep(4, "", "3");
                            // jumpStep(14, "denied2", "3");
                          });
                      }
                    } else {
                      page1Overlay.value = false;
                      jumpStep(4, "", "1");
                    }
                  } else {
                    page1Overlay.value = false;
                    jumpStep(4, "", "1");
                  }
                } else if (
                  otp.value.principalStatus === "falseBoth" ||
                  otp.value.otpMobile.status === "falseOtp" ||
                  otp.value.otpEmail.status === "falseEmail"
                ) {
                  page1Overlay.value = false;
                  jumpStep(3, "", "1");
                } else {
                  if (otp.value.verified == "true") {
                    if (ccFormValue.value.basicInformation.idType == "0") {
                      if (exist.value == true) {
                        page1Overlay.value = false;
                        jumpStep(4, "", "3");
                      } else {
                        const requestModel = {
                          webFormRequestId: ccFormValue.value.webFormRequestId,
                          name: ccFormValue.value.basicInformation.name,
                          icNo: ccFormValue.value.basicInformation.idNo,
                          dateOfBirth: ccFormValue.value.basicInformation.dob,
                          cardBusinessCode: prop.cardId,
                          nationalityCode:
                            ccFormValue.value.basicInformation.nationality,
                          phoneNo:
                            ccFormValue.value.basicInformation.countryCode +
                            ccFormValue.value.basicInformation.mobileNo,
                          grossIncome:
                            ccFormValue.value.basicInformation.grossSalary.toString(),
                          netIncome:
                            ccFormValue.value.basicInformation.netSalary.toString(),
                          refNo: ccFormValue.value.refNo,
                        };
                        MasterService.preAssesment(
                          requestModel,
                          ccFormValue.value.token
                        )
                          .then((res) => {
                            if (res.status == 200) {
                              // page3Overlay.value = false;
                              ccFormValue.value.preAss.webFormRequestId =
                                res.data.responseModel.webFormRequestId;
                              ccFormValue.value.dsrBurst =
                                res.data.responseModel.dSRStatus;
                              ccFormValue.value.dropOffStep = 5;
                              creditLimit.value =
                                res.data.responseModel.preAssessLimit;
                              ccFormValue.value.ctosScore =
                                res.data.responseModel.ctosScore;
                              if (
                                res.data.responseModel.preAssessStatus ==
                                "DECLINED"
                              ) {
                                page1Overlay.value = false;
                                jumpStep(14, "denied2", "3");
                              } else {
                                ccFormValue.value.ekyc.preStatus =
                                  res.data.responseModel.preAssessStatus;
                                page1Overlay.value = false;
                                jumpStep(4, "", "3");
                              }
                            }
                          })
                          .catch((e) => {
                            if (
                              e.response &&
                              e.response.data.code == "WB-401"
                            ) {
                              // EndSession
                              isTimeOut.value = false;
                              isSessionEnd.value = true;
                            }
                            page1Overlay.value = false;
                            ccFormValue.value.ekyc.preStatus = "DOWN";
                            jumpStep(4, "", "3");
                            // jumpStep(14, "denied2", "3");
                          });
                      }
                    } else {
                      page1Overlay.value = false;
                      jumpStep(4, "", "1");
                    }
                  } else {
                    page1Overlay.value = false;
                    jumpStep(3, "", "1");
                  }
                }
              }
            }
          }
        })
        .catch((e) => {
          page1Overlay.value = false;
          if (e.response && e.response.data.code == "WB-401") {
            // EndSession
            isTimeOut.value = false;
            isSessionEnd.value = true;
          }
        });
    };
  } else {
    MasterService.basicInformationSubmit(requestModel).then((res) => {
      if (res.status == 200) {
        page1Overlay.value = false;
        newForm.value = false;
        const dropOffValue = ref(
          convertValue(res.data.responseModel.dropOffStep)
        );
        ccFormValue.value.webFormRequestId =
          res.data.responseModel.webFormRequestId;
        ccFormValue.value.token = res.data.responseModel.token;
        ccFormValue.value.refNo = res.data.responseModel.refNo;
        if (ccFormValue.value.basicInformation.idType == "0") {
          const requestModel2 = {
            webFormRequestId: ccFormValue.value.webFormRequestId,
            cardId: prop.cardId,
            icNumber: ccFormValue.value.basicInformation.idNo,
          };
          MasterService.validate(requestModel2, ccFormValue.value.token)
            .then((res) => {
              if (res.status == 200) {
                ccFormValue.value.refNo =
                  res.data.responseModel.cardList[0].refNo;
                ccFormValue.value.dropOffStep =
                  res.data.responseModel.cardList[0].dropOffStep;
                jumpStep(2, "", "1");
              }
            })
            .catch((e) => {
              if (e.response && e.response.data.code == "WB-401") {
                // EndSession
                isTimeOut.value = false;
                isSessionEnd.value = true;
              }
              page1Overlay.value = false;
            });
        } else {
          const requestModel2 = {
            webFormRequestId: ccFormValue.value.webFormRequestId,
            cardId: prop.cardId,
            icNumber: ccFormValue.value.basicInformation.idNo,
          };
          MasterService.validate(requestModel2, ccFormValue.value.token)
            .then((res) => {
              if (res.status == 200) {
                ccFormValue.value.refNo =
                  res.data.responseModel.cardList[0].refNo;
                ccFormValue.value.dropOffStep =
                  res.data.responseModel.cardList[0].dropOffStep;
              }
            })
            .catch((e) => {
              if (e.response && e.response.data.code == "WB-401") {
                // EndSession
                isTimeOut.value = false;
                isSessionEnd.value = true;
              }
              page1Overlay.value = false;
            });
          ccFormValue.value.dropOffStep = 3;
          jumpStep(3, "", "1");
        }
      }
    });
  }
}
